import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './Nav.module.css';
import logo from '../../assets/citizens-logo.svg';
import burgerIcon from '../../assets/hamburger-icon.svg';
import xIcon from '../../assets/mobile-nav-x-icon.svg';

const Nav = () => {
  const location = useLocation(); // Get current location
  const [isMobileNavVisible, setIsMobileNavVisible] = useState(false); // State for mobile nav visibility
  const [isNavbarVisible, setIsNavbarVisible] = useState(true); // State for navbar visibility
  const [lastScrollY, setLastScrollY] = useState(0); // State to store the last scroll position

  const toggleMobileNav = () => {
    setIsMobileNavVisible(!isMobileNavVisible);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY) {
        // Scrolling down
        setIsNavbarVisible(false);
      } else {
        // Scrolling up
        setIsNavbarVisible(true);
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

  return (
    <header className={`${styles.header} ${isNavbarVisible ? styles.visible : styles.hidden}`}>
      <div className={styles.headerContent}>
        <div className={styles.logo}>
          <Link to="/">
            <img src={logo} alt="Citizens Logo" className={styles.logoImage} /> {/* Use the SVG file */}
          </Link>
        </div>
        <nav className={styles.links}>
          <Link to="/" className={location.pathname === '/' ? `${styles.navLink} ${styles.active}` : styles.navLink}>
            Home
          </Link>
          <Link to="/about" className={location.pathname === '/about' ? `${styles.navLink} ${styles.active}` : styles.navLink}>
            About
          </Link>
        </nav>
      </div>
      <div className={styles.mobileNav}>
        <div className={styles.mobileNavContent}>
          <div>
            <Link to="/">
              <img className={styles.logoImage} src={logo} alt="Citizens Logo" />
            </Link>
          </div>
          <div onClick={toggleMobileNav} className={styles.navToggleButton} aria-label="Toggle navigation">
            <img className={styles.burgerIcon} src={burgerIcon} alt="hamburger icon" style={{ display: isMobileNavVisible ? 'none' : 'block' }} />
            <img className={styles.xIcon} src={xIcon} alt="close icon" style={{ display: isMobileNavVisible ? 'block' : 'none' }} />
          </div>
        </div>
        {isMobileNavVisible && (
          <div className={styles.burgerLinks}>
            <Link to="/" onClick={toggleMobileNav}>Home</Link>
            <Link to="/about" onClick={toggleMobileNav}>About</Link>
          </div>
        )}
      </div>
    </header>
  );
};

export default Nav;